import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import CardItem from '../../CardItem';
import { getRecipesFromDB } from '../../../AwsFunctions';
import './../../Cards.css';

function Recipes() {
    const [recipes, setRecipes] = useState([]);

    function chunkArray(myArray, chunk_size) {
        var index = 0;
        var arrayLength = myArray.length;
        var tempArray = [];

        for (index = 0; index < arrayLength; index += chunk_size) {
            let myChunk = myArray.slice(index, index + chunk_size);
            // Do something if you want with the group
            tempArray.push(myChunk);
        }
        return tempArray;
    }

    useEffect(() => {
        getRecipesFromDB().then(data => {
            var result = chunkArray(data, 3);
            setRecipes(result.map((chunk) => (
                <ul className='cards__items' key={chunk.toString()}>
                    {chunk.map((recipe) => (
                        <CardItem
                            key={recipe.recipeId}
                            title={recipe.title}
                            labels={recipe.labels}
                            img={recipe.img}
                            path={recipe.path}
                        />
                    ))}
                </ul>
            )));
        });
    }, []);

    return (
        <>
            <Helmet>
                <title>Kai Cheng | Recipes</title>
                <meta name='description' content='Kai Cheng | Recipes' />
                <link rel='canonical' href='https://www.kaicheng.ca/recipes/' />
            </Helmet>
            <div className='cards'>
                <h1>Check out these Recipes!</h1>
                <div className='cards__container'>
                    <div className='cards__wrapper'>
                        {recipes}
                    </div>
                </div>
            </div>
        </>
    );
}

export default Recipes;
